import { graphql } from '@/gql';

export const GET_BENACHRICHTIGUNGEN = graphql(`
  query GetBenachrichtigungen($standortId: String!) {
    navigation_benachrichtigungen2(standortId: $standortId) {
      fehlendeArbeitszeit {
        id
        status
        datum
        mitarbeiter {
          vorname
          nachname
          bildUrl
          arbeitnehmertyp
          id
        }
        arbeitsbereich {
          id
          name
          markierung
        }
      }
      abwesenheitsantraege {
        bis
        von
        grund
        id
        markierung
        mitarbeiter {
          bildUrl
          id
          nachname
          vorname
          arbeitnehmertyp
        }
      }
      fristen {
        id
        ablaufZeitpunkt
        grund
        gelesen
        mitarbeiter {
          id
          vorname
          nachname
          bildUrl
          arbeitnehmertyp
        }
      }
      krankmeldungen {
        istKindkrank
        mitarbeiter {
          id
          bildUrl
          vorname
          nachname
          istExtern
          arbeitnehmertyp
        }
        voraussichtlichVon
        voraussichtlichBis
      }
      dokumente {
        erstellungsDatum
        id
        mitarbeiter {
          id
          bildUrl
          vorname
          nachname
          arbeitnehmertyp
        }
        name
      }
      mitarbeiterantraege {
        id
        erstellungsDatum
        mitarbeiter {
          bildUrl
          id
          nachname
          vorname
          arbeitnehmertyp
        }
      }

      schichttauschantraege {
        id
        bemerkungAntragsteller
        erstellungsDatum
        schicht {
          arbeitsbereich {
            id
            markierung
            name
          }
          beginn
          ende
        }
        mitarbeiter {
          id
          bildUrl
          vorname
          nachname
          arbeitnehmertyp
          arbeitsbereich {
            id
            name
            markierung
          }
        }
      }
    }
  }
`);

export const GET_MITARBEITER_BY_STANDORT_ID = graphql(`
  query GetMitarbeiter($standortId: String!) {
    navigation_mitarbeiter(standortId: $standortId) {
      id
      vorname
      nachname
      bildUrl
      arbeitnehmertyp
      arbeitsbereich {
        id
        name
        markierung
      }
    }
  }
`);
